import { Chip } from "@mui/material";
import { styled } from "@mui/system";
import { CTA_BUTTONS_STYLES } from "../../Shared/styles";

export const ChipButtonContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
});

export const ChipStyled = styled(Chip)({
    backgroundColor: "transparent",
    boxShadow: "none",
    color: "var(--community-color-light-steal-blue)",
    border: "1px solid var(--community-color-light-steal-blue)",
    width: "fit-content",
    margin: "0 auto",
    transition: "all 300ms",
    span: {
        fontWeight: "500",
        fontSize: "14px",
    },
    "&:hover": {
        backgroundColor: "var(--community-color-light-steal-blue)",
        span: {
            transition: "all 300ms",
            color: "var(--community-color-snow-white)",
        },
    },
    ...CTA_BUTTONS_STYLES,
});
